import { sortBy, uniq } from "lodash";
import { MISC_SERIES } from "../../../classes/SaleItem.js";
import { rankBrands } from "../../../util/vendorUsage.js";

export const isUser = (state) => (uid) => {
  return state.user && state.user.id === uid;
};

export const isAdmin = (state) => () => {
  return state.user && state.user.isAdmin;
};

export const isSuper = (state) => () => {
  return state.user && state.user.isSuper;
};

export const isEmployee = (state) => () => {
  return state.user && state.user.isEmployee;
};

export const isCustomer = (state) => () => {
  return state.user && state.user.isCustomer;
};

export const hasRole = (state) => (role) => {
  return state.user && state.user.hasRole(role);
};

export const isCompanyAdmin = (state) => (cid) => {
  return state.user && cid in state.claims.adminOf;
};

export const isCompanyEmployee = (state) => (cid) => {
  return state.user && cid in state.claims.employeeOf;
};

export const isLoggedIn = (state) => () => {
  return Boolean(state.user);
};

export const permissions = (state) => (doc) => {
  return doc.can(state.user);
};

export const can = (state) => (action, doc) => {
  return doc.can(state.user, action);
};

export const brands = (state) => {
  return sortBy(
    Object.values(state.companies)
      .filter(
        (c) =>
          c.data.status === "active" &&
          c.data.type === "vendor" &&
          c.data.vendorType === "material"
      )
      .map((c) => ({
        id: c.id,
        name: c.data.name,
        series: uniq([...c.data.series, ...MISC_SERIES]).sort(),
      })),
    "name"
  );
};

// The current user's brands, most used on their recent projects first, then
// their primary (first) location's (util/vendorUsage.js). Cached by Vuex.
export const brandRanking = (state) => {
  if (!state.user) return [];
  return rankBrands(
    Object.values(state.projects || {}),
    state.user.id,
    (state.user.data.locations || [])[0]
  );
};

export const leadTimeByBrand = (state) => {
  const leadTimes = state.leadTimes || {};
  const map = {};
  for (const lt of Object.values(leadTimes)) {
    if (lt.vendorName) {
      map[lt.vendorName] = lt;
    }
    // Fallback: also map by raw brand value for legacy entries
    if (lt.data?.brand && !map[lt.data.brand]) {
      map[lt.data.brand] = lt;
    }
  }
  return map;
};

export const userOrigin = (state) => {
  let address = null;
  if (state.user) {
    if (state.user.locations.length) {
      address = state.user.locations[0].address;
    } else if (state.user.addresses.length) {
      address = state.user.addresses[0];
    }
  }
  return address && address.lat && address.lng
    ? { lat: address.lat, lng: address.lng }
    : null;
};
